import React, { Component } from "react";
import Button from "@material-ui/core/Button";
import BasePage from "../../components/Page/BasePage";

class NexoidLink extends BasePage {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    return (
      <div>
        <Button
          aria-label="Nexoid Website"
          href={"https://www.nexoid.com" + this.getNexoidUrlQs()}
          style={{
            backgroundColor: "#0099ED",
            borderRadius: 60,
            color: "#ffffff"
          }}
        >
          <i
            className="material-icons"
            style={{ color: "#ffffff", paddingRight: 8 }}
          >
            arrow_back
          </i>
          www.nexoid.com
        </Button>
      </div>
    );
  }
}

export default NexoidLink;



// WEBPACK FOOTER //
// ./src/components/Page/NexoidLink.js